export enum TradingStatus {
  Active = 1,
  Dissolved = 0,
}
